import Box from "@mui/material/Box";
import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useLazySvgImport } from "@/hooks/lazy-svg";

interface Props {
  iso: string | undefined;
  /** 1 = red, 2 = yellow, 3 = information. */
  status: number;
  label: string;
}

/** A lit lamp in the point details: its symbol on the lamp's colour, as on the dashboard. */
export function PointTellTale({ iso, status, label }: Props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { Svg } = useLazySvgImport("ISO_7000_-_Ref-No_" + (iso && iso !== "-1" ? iso : "NOICON"));
  const color =
    status === 1 ? theme.palette.error.main : status === 2 ? theme.palette.warning.main : theme.palette.primary.main;
  const statusText =
    status === 1 ? t("faultOverview.red") : status === 2 ? t("faultOverview.yellow") : t("faultOverview.information2");

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, my: 0.25 }}>
      <Box
        sx={{
          width: 24,
          height: 24,
          flexShrink: 0,
          display: "flex",
          overflow: "hidden",
          borderRadius: "50%",
          border: 1,
          borderColor: "common.black",
          bgcolor: color,
        }}
      >
        {Svg ? <Box component="img" src={Svg} alt="" sx={{ width: "100%", height: "100%" }} /> : null}
      </Box>
      <Typography variant="caption">
        {label}: {statusText}
      </Typography>
    </Box>
  );
}
